import palette from '../../theme/palette';

// export const data = {
//   labels: ['1 Aug', '2 Aug', '3 Aug', '4 Aug', '5 Aug', '6 Aug'],
//   datasets: [
//     {
//       label: 'This year',
//       backgroundColor: palette.primary.main,
//       data: [18, 5, 19, 27, 29, 19, 20]
//     },
//     {
//       label: 'Last year',
//       backgroundColor: palette.neutral,
//       data: [11, 20, 12, 29, 30, 25, 13]
//     }
//   ]
// };

export const data = {
    labels: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    datasets: [
        {
            label: 'Backbone (N,CA,C,O)',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [11, 10, 9, 8, 7, 6, 5, 4, 3]
        },
        {
            label: 'Heavy atoms',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [10, 9, 8, 7, 6, 5, 4, 3, 2]
        }
    ],

};


export const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    legend: {display: false},
    cornerRadius: 40,
    elements: {
        line: {
            tension: 0.1,
            fill: false
        },
        point: {
            radius: 1,
            backgroundColor: '#fff',
            borderWidth: 1,
            borderColor: 'rgba(75,192,192,1)',
            hitRadius: 10,
            hoverRadius: 5,
            hoverBorderWidth: 2,
        },
    },
    tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        borderWidth: 1,
        borderColor: palette.divider,
        backgroundColor: palette.white,
        titleFontColor: palette.text.primary,
        bodyFontColor: palette.text.secondary,
        footerFontColor: palette.text.secondary
    },
    layout: {padding: 0},
    scales: {
        xAxes: [
            {
                barThickness: 12,
                maxBarThickness: 10,
                barPercentage: 0.5,
                categoryPercentage: 0.5,
                ticks: {
                    fontColor: palette.text.secondary
                },
                gridLines: {
                    display: false,
                    drawBorder: false
                }
            }
        ],
        yAxes: [
            {
                ticks: {
                    fontColor: palette.text.secondary,
                    beginAtZero: true,
                    min: 0
                },
                gridLines: {
                    borderDash: [2],
                    borderDashOffset: [2],
                    color: palette.divider,
                    drawBorder: false,
                    zeroLineBorderDash: [2],
                    zeroLineBorderDashOffset: [2],
                    zeroLineColor: palette.divider
                }
            }
        ]
    }
};